import React from 'react';
import { Button, Modal, Alert, ModalBody } from 'reactstrap';

export const ContactModal = props => {
	return (
		<Modal isOpen={props.modal} toggle={props.toggle}>
			<ModalBody>
				<Alert
					color='info'
					style={{
						width: '100%',
						textAlign: 'center'
					}}
				>
					<p>{props.message}</p>
				</Alert>
				<div style={{ float: 'right' }}>
					<Button color='secondary' onClick={props.toggle}>
						Close
					</Button>
				</div>
			</ModalBody>
		</Modal>
	);
};

export const PRIVACY_POLICY_LINKS = [
	{
		key: 'EU_T_C',
		url: 'https://campaign.odw.sony-europe.com/dynamic/terms-conditions/index.jsp?country=gb&amp;language=en',
		label: 'TERMS AND CONDITIONS OF WEBSITE USE'
	},
	{
		key: 'EU_PRIVACY_POLICY',
		url: 'https://www.sony.co.uk/eu/pages/privacy/en_GB/privacy_overview.html',
		label: 'PRIVACY POLICY'
	},
	{
		key: 'EU_T_C_S',
		url: 'https://www.sony.co.uk/store/TermsAndConditions',
		label: 'TERMS AND CONDITIONS OF SALE'
	}
];
